<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

// Sub-navegación de Informes (Victor 2026-05-23). El sidebar Kommo-style no
// muestra submenús, así que la navegación entre reportes vive aquí.
const tabs = [
  { label: 'Métricas Avanzadas', name: 'advanced_metrics_reports', star: true },
  { label: 'Centro de Redes', name: 'social_reports', star: true },
  { label: 'Conversaciones', name: 'conversation_reports' },
  { label: 'Agentes', name: 'agent_reports_index', activeOn: ['agent_reports_show'] },
  { label: 'Bandejas', name: 'inbox_reports_index', activeOn: ['inbox_reports_show'] },
  { label: 'Equipos', name: 'team_reports_index', activeOn: ['team_reports_show'] },
  { label: 'Etiquetas', name: 'label_reports_index', activeOn: ['label_reports_show'] },
  { label: 'CSAT', name: 'csat_reports' },
  { label: 'SLA', name: 'sla_reports' },
  { label: 'Bots', name: 'bot_reports' },
];

// Solo se muestran los informes propios (Métricas Avanzadas y Redes). Las 8
// pestañas estándar de Chatwoot quedan ocultas de la barra a pedido de Victor
// (2026-06-04); sus rutas siguen existiendo, solo no se listan aquí.
const visibleTabs = tabs.filter(tab => tab.star);

const isActive = tab =>
  route.name === tab.name || (tab.activeOn || []).includes(route.name);

// Métricas Avanzadas usa pantalla completa (centro de mando); el resto de
// Informes mantiene el ancho centrado clásico.
const isFullWidth = computed(() =>
  ['advanced_metrics_reports', 'social_reports'].includes(route.name)
);
</script>

<template>
  <div class="overflow-auto bg-n-surface-1 w-full" :class="isFullWidth ? 'px-3' : 'px-6'">
    <div class="pb-12" :class="isFullWidth ? 'w-full' : 'max-w-6xl mx-auto'">
      <nav class="am-subnav">
        <RouterLink
          v-for="tab in visibleTabs"
          :key="tab.name"
          :to="{ name: tab.name }"
          class="am-tab"
          :class="{ 'am-tab--active': isActive(tab), 'am-tab--star': tab.star }"
        >
          <span v-if="tab.star" class="am-star">✦</span>{{ tab.label }}
        </RouterLink>
      </nav>
      <router-view />
    </div>
  </div>
</template>

<style scoped>
.am-subnav {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  padding: 14px 0 18px;
  margin-bottom: 4px;
}
.am-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border-radius: 10px;
  font-size: 12.5px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.55);
  border: 1px solid transparent;
  transition: 0.16s;
  text-decoration: none;
}
.am-tab:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.05);
}
.am-tab--active {
  color: #fbbf24;
  background: rgba(251, 191, 36, 0.1);
  border-color: rgba(251, 191, 36, 0.3);
}
.am-tab--star {
  color: #fbbf24;
}
.am-tab--star.am-tab--active {
  box-shadow: 0 0 14px rgba(251, 191, 36, 0.18);
}
.am-star {
  font-size: 11px;
}
</style>
